export const serviceTranslations: Record<string, Record<string, string>> = {
  en: {
    "Food": "Food",
    "Health & Wellness": "Health & Wellness",
    "Tutoring": "Tutoring",
    "Beauty": "Beauty",
    "Catering": "Catering",
    "Photography": "Photography",
    "Hairdresser": "Hairdresser",
    "Cleaning": "Cleaning",
    "Legal": "Legal",
    "Babysitting": "Babysitting",
    "Pet Sitting": "Pet Sitting",
    "Delivery & Moving": "Delivery & Moving",
    "Coaching": "Coaching",
    "Entertainment & Art": "Entertainment & Art",
    "House Repairing": "House Repairing",
    "Travel": "Travel",
    "Childcare": "Childcare",
    "IT Support": "IT Support",
    "Music Lessons": "Music Lessons",
    "Language Support": "Language Support",
  },
  pt: {
    "Food": "Comida",
    "Health & Wellness": "Saúde e Bem-estar",
    "Tutoring": "Aulas particulares",
    "Beauty": "Beleza",
    "Catering": "Buffet",
    "Photography": "Fotografia",
    "Hairdresser": "Cabeleireiro(a)",
    "Cleaning": "Limpeza",
    "Legal": "Assessoria jurídica",
    "Babysitting": "Babá",
    "Pet Sitting": "Cuidado de animais",
    "Delivery & Moving": "Entrega e mudança",
    "Coaching": "Coaching",
    "Entertainment & Art": "Entretenimento e Arte",
    "House Repairing": "Reparos domésticos",
    "Travel": "Viagem",
    "Childcare": "Cuidados infantis",
    "IT Support": "Suporte de TI",
    "Music Lessons": "Aulas de música",
    "Language Support": "Apoio com idiomas",
  },
};

export const servicesPageTranslations = {
  en: {
    title: "Services",
  },
  pt: {
    title: "Serviços",
  },
};


export const featuredCarouselTranslations = {
  en: {
    heading: "Most searched services",
    explore: "Explore",
    labels: {
      Food: "Food",
      "Health & Wellness": "Health & Wellness",
      Babysitting: "Babysitting",
      Tutoring: "Tutoring",
      Beauty: "Beauty",
      Photography: "Photography",
    },
  },
  pt: {
    heading: "Serviços mais buscados",
    explore: "Explorar",
    labels: {
      Food: "Comida",
      "Health & Wellness": "Saúde e Bem-estar",
      Babysitting: "Babá",
      Tutoring: "Aulas particulares",
      Beauty: "Beleza",
      Photography: "Fotografia",
    },
  },
};


export const servicesFilterTranslations = {
  pt: {
    heading: "Todas as Categorias",
    placeholder: "Buscar serviços",
    button: "Filtrar",
  },
  en: {
    heading: "All Categories",
    placeholder: "Search services",
    button: "Filter",
  },
};


export const serviceOfferBannerTexts = {
  pt: {
    heading: "Você é brasileiro e oferece um serviço?",
    description: "Cadastre-se e ajude a comunidade a te encontrar.",
    button: "Cadastrar serviço",
  },
  en: {
    heading: "Are you a Brazilian offering a service?",
    description: "Get listed here and help others in the community find you.",
    button: "Get Listed",
  },
};
